import type { ModelAddButtonProps } from "./model-add-button.type";

import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { getModelTranslationKey } from "@/modules/model";
import { useSidePanel } from "@/modules/side-panel";

/** @deprecated - Create specific button for each model instead */
const ModelAddButton = ({
  model,
  component,
  shortButtonText,
  buttonTitle,
  sidePanelTitle,
  ...buttonProps
}: ModelAddButtonProps) => {
  const { t } = useTranslation();
  const { openSidePanel } = useSidePanel();

  const modelKey = getModelTranslationKey(model);
  const title = t(`${modelKey}:add.label`);

  const onAddClick = () => {
    openSidePanel({
      title: sidePanelTitle ?? title,
      component,
    });
  };

  return (
    <Button icon={<PlusOutlined />} onClick={onAddClick} {...buttonProps}>
      {shortButtonText ? t("global:add") : buttonTitle || title}
    </Button>
  );
};

export default ModelAddButton;
